'use strict';

var jQuery = require('jquery');
var React = require('react');
var ReactDOM = require('react-dom');
var Reflux = require('reflux');

var isNode = typeof document === 'undefined';
if (!isNode) {
    require('./overlay.scss');
}

var Constants = require('../constants');
var Events = require('../events');
var Global = require('../global');

var LocalStore = require('../store');
var Actions = LocalStore.Actions;
var Store = LocalStore.Store;

var DeviceImage = Global.DeviceImage;

var Overlay = React.createClass({
    mixins: [
        // In-memory; set by Collections.jsx
        Reflux.connect(Events.Store, 'topButtonVisible'),

        // localStorage; custom Olark Greeter (behaviour is: pop up greeting message after 120 ms)
        Reflux.connect(Store, 'store'),
    ],

    componentDidMount: function() {
        if (typeof olark === 'undefined') {
            return;
        }
        
        var _this = this;

        if (!this.state.store.showChat) {
            olark('api.box.hide');
        } else {
            olark('api.box.expand');
        }

        var greetingTimeout = null;

        olark('api.chat.onOperatorsAvailable', function() {
            if (!_this.state.store.didGreet) {
                var startTime_ms = _this.state.store.sessionStartTime ? _this.state.store.sessionStartTime : new Date().getTime();
                var timeDiff_ms = (new Date().getTime() - startTime_ms);
                var delay_ms = Math.max(0, 120*1000 - timeDiff_ms);

                greetingTimeout = setTimeout(function() {
                    Actions.setDidGreet(true);
                    olark('api.chat.sendMessageToVisitor', {
                        body: 'Thanks for your interest in our Modern Furniture Designs. Can we help you with anything?'
                    });
                }, delay_ms);
            }
        });
        olark('api.chat.onOperatorsAway', function() {
            clearTimeout(greetingTimeout);

            // Operator signing out will leave minimized bar, so hide it
            if (!_this.state.showChat) {
                olark('api.box.hide');
            }
        });

        // olark('api.box.onShow', function() {
        // });
        olark('api.box.onExpand', function() {
            Actions.setShowChat(true);
        });
        olark('api.box.onShrink', function() {
            Actions.setShowChat(false);
            olark('api.box.hide');
        });
        // olark('api.box.onHide', function() {
        // });
    },
    componentDidUpdate(prevProps, prevState) {
        var olark = document.getElementById('habla_window_div');
        if (olark) {
            var edge = this.refs.chatButton.getBoundingClientRect().right;
            if (edge) {
                var w = document.documentElement.clientWidth;
                var x = w - edge;
                olark.style.right = (x + 'px');
                olark.style.marginRight = 0;
            }
        };
    },
    liveChat: function() {
        if (typeof(olark) === 'undefined') {
            alert('Sorry - live chat is currently disabled');
            return;
        }
        olark('api.box.expand');
    },
    handleTopClick: function() {
        jQuery('html,body').animate({
          scrollTop: 0,
        }, 600);
    },
    render: function() {
        return (
            <div className='overlay'>
                {this.state.topButtonVisible ?
                    <div className='overlay-top' onClick={this.handleTopClick} ref='topButton' >
                        <DeviceImage src='overlay/top.png' alt='Top' width={27} height={27}/>
                    </div>
                : null}
            </div>
        );
    }
});

module.exports = Overlay;



// WEBPACK FOOTER //
// ./src/components/overlay.jsx